import repository from './repsitory'

const resource = '/facturaPlus'

export default {

    getSkuFacturaPlus () {
        return repository.get(`${resource}/getSkuFacturaPlus`)
    },
    syncFilesFacturaPlus () {
        return repository.get(`${resource}/syncFilesFacturaPlus`)
    },
    syncStockProducts () {
        return repository.get(`${resource}/syncStockProducts`)
    },
    syncProductImages () {
      return repository.get(`${resource}/syncProductImages`)
  },
}
